/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * This directive links the `submit` method of a form's DOM element to the form controller that
 * angular creates, allowing forms to be submitted manually.
 *
 * @module enervee_utils.common
 */
 function addFormSubmitDirective() {
     return {
         restrict: 'A',
         require: 'form',
         link: function(scope, elem, attrs, formCtrl) {
             formCtrl.submit = function () {
                 if (formCtrl.$valid) {
                     elem[0].submit();
                 }
             };
         }
     };
 }

module.exports = addFormSubmitDirective;